import React from 'react';
import { useTranslation } from 'react-i18next';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';

import './DaysField.css';

const DaysField = ({ name, onChange, fixedWidth, single }) => {
    const { t } = useTranslation();

    const days = [ 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const options = days.map((day, i) => ({
        key: i,
        text: t(`common.${day}`),
        value: (i + 1) % 7
    }));

    const onFieldChange = (value) => {
        return onChange ? onChange(value) : true;
    }

    return single ? (
        <SelectField
            name={ name }
            options={ options }
            placeholder={ t('common.choose_a_day') }
            onSelectChange={ onFieldChange }
            fixedWidth={ fixedWidth }
            clearable
        />
    ) : (
        <MultiSelectField
            name={ name }
            options={ options }
            placeholder={ t('common.choose_some_days') }
            onSelectChange={ onFieldChange }
            fixedWidth={ fixedWidth }
        />
    );
}

export default DaysField;
